import { render, staticRenderFns } from "./ProductosMasivoAgendados.vue?vue&type=template&id=828f2c32&scoped=true"
import script from "./ProductosMasivoAgendados.vue?vue&type=script&lang=js"
export * from "./ProductosMasivoAgendados.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "828f2c32",
  null
  
)

export default component.exports